
$(document).ready(function(){
  // Show the popup when the trigger is clicked
  $('.custom_com_popu_C').click(function(){
    $('.comapare_open').show();
    $("body").addClass("overflow_hidden");
// Function to detect the operating system
function detectOS() {
  var platform = window.navigator.platform;
  var windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];

  for (var i = 0; i < windowsPlatforms.length; i++) {
    if (platform.indexOf(windowsPlatforms[i]) !== -1) {
      return 'Windows';
    }
  }

  return 'Other';
}

// Function to detect if the device is a desktop
function isDesktop() {
  var userAgent = window.navigator.userAgent;
  return !(/Mobile|Tablet/.test(userAgent));
}

// Add class only if the OS is Windows and the device is a desktop
if (detectOS() === 'Windows' && isDesktop()) {
  $("body").addClass("custom-modal_open");
}

  });

  // Close the popup when the close button is clicked
  $('.custom_compare_popup .close-btn').click(function(){
    $('.comapare_open').hide();
    // $(".custom_comaprison_popup_com").hide();
  });
    $('.close-btn-more-custom').click(function(){
    $('.comapare_open').hide();
    // $(".custom_comaprison_mor").hide();
  });

  // Close the popup when clicking outside the popup content
  $(window).click(function(event) {
    if ($(event.target).hasClass('comapare_open')) {
      $('.comapare_open').hide();
        $("body").removeClass("overflow_hidden");
// Function to detect if the OS is Windows
function isWindows() {
  var platform = window.navigator.platform;
  var windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];

  for (var i = 0; i < windowsPlatforms.length; i++) {
    if (platform.indexOf(windowsPlatforms[i]) !== -1) {
      return true;
    }
  }

  return false;
}

// Function to detect if the device is a desktop
function isDesktop() {
  var userAgent = window.navigator.userAgent;
  return !(/Mobile|Tablet/.test(userAgent));
}

// Remove class only if the OS is Windows and the device is a desktop
if (isWindows() && isDesktop()) {
  $("body").removeClass("custom-modal_open");
}

    }
  });
});


$(document).ready(function(){
  // Show the popup when the trigger is clicked
  $('.custom_more_popu_C').click(function(){
    $('.custom_moreinfo_oprn').show();
       $("body").addClass("overflow_hidden");
// Function to detect the operating system
function detectOS() {
  var platform = window.navigator.platform;
  var windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];

  for (var i = 0; i < windowsPlatforms.length; i++) {
    if (platform.indexOf(windowsPlatforms[i]) !== -1) {
      return 'Windows';
    }
  }

  return 'Other';
}

// Function to detect if the device is a desktop
function isDesktop() {
  var userAgent = window.navigator.userAgent;
  return !(/Mobile|Tablet/.test(userAgent));
}

// Add class only if the OS is Windows and the device is a desktop
if (detectOS() === 'Windows' && isDesktop()) {
  $("body").addClass("custom-modal_open");
}

  });

  // Close the popup when the close button is clicked
  $('.close-btn').click(function(){
    $('.custom_moreinfo_oprn').hide();
       $("body").removeClass("overflow_hidden");
// Function to detect if the OS is Windows
function isWindows() {
  var platform = window.navigator.platform;
  var windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];

  for (var i = 0; i < windowsPlatforms.length; i++) {
    if (platform.indexOf(windowsPlatforms[i]) !== -1) {
      return true;
    }
  }

  return false;
}

// Function to detect if the device is a desktop
function isDesktop() {
  var userAgent = window.navigator.userAgent;
  return !(/Mobile|Tablet/.test(userAgent));
}

// Remove class only if the OS is Windows and the device is a desktop
if (isWindows() && isDesktop()) {
  $("body").removeClass("custom-modal_open");
}

  });

  // Close the popup when clicking outside the popup content
  $(window).click(function(event) {
    if ($(event.target).hasClass('custom_moreinfo_oprn')) {
      $('.custom_moreinfo_oprn').hide();
        $("body").removeClass("overflow_hidden");
// Function to detect the operating system and if it's a desktop
function detectDesktopWindows() {
  var userAgent = window.navigator.userAgent,
      platform = window.navigator.platform,
      windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
      isWindows = false,
      isDesktop = false;

  for (var i = 0; i < windowsPlatforms.length; i++) {
    if (platform.indexOf(windowsPlatforms[i]) !== -1) {
      isWindows = true;
      break;
    }
  }

  // Check for desktop user agents (not comprehensive, but common desktop browsers)
  if (userAgent.indexOf('Mobile') === -1 && userAgent.indexOf('Tablet') === -1) {
    isDesktop = true;
  }

  return isWindows && isDesktop;
}

// Remove class only if the OS is Windows and the device is a desktop
if (detectDesktopWindows()) {
  $("body").removeClass("custom-modal_open");
}

    }
  });
});



// chose modal
  // document.addEventListener('DOMContentLoaded', () => {
  //   const button = document.getElementById('custom_product-choose-btn_S');
  //   const targetSection = document.querySelector('.custom-product_Section');

  //   const observer = new IntersectionObserver((entries) => {
  //     entries.forEach(entry => {
  //       console.log(`Entry: ${entry.target.className}, isIntersecting: ${entry.isIntersecting}`);
  //       if (entry.isIntersecting) {
  //         button.classList.add('hidden');
  //         button.style.display = 'none'; // Ensure the button is hidden
  //       } else {
  //         button.classList.remove('hidden');
  //         button.style.display = 'block'; 
  //       }
  //     });
  //   }, {
  //     threshold: 0.1 
  //   });

  //   observer.observe(targetSection);


  //   const rect = targetSection.getBoundingClientRect();
  //   if (rect.top < window.innerHeight && rect.bottom > 0) {
  //     console.log('Initial load: Section is in view, hiding button');
  //     button.classList.add('hidden');
  //     button.style.display = 'none';
  //   } else {
  //     console.log('Initial load: Section is not in view, showing button');
  //     button.classList.remove('hidden');
  //     button.style.display = 'block'; 
  //   }
  // });

// document.addEventListener('DOMContentLoaded', () => {
//   const button = document.getElementById('main_custom_checkout_product_c');
//   const targetSection = document.querySelector('.custom-product_Section');

//   const observer = new IntersectionObserver((entries) => {
//     entries.forEach(entry => {
//       if (entry.isIntersecting) {
//         button.classList.add('hidden');
//         button.style.display = 'none'; // Ensure the button is hidden
//       } else {
//         button.classList.remove('hidden');
//         button.style.display = 'block';
//       }
//     });
//   }, {
//     threshold: 0.1
//   });

//   observer.observe(targetSection);
// });

document.addEventListener('DOMContentLoaded', () => {
  const button = document.getElementById('main_custom_checkout_product_c');

  if (button) {
    const scrollThreshold = 100; // Show button after 100px scroll

    window.addEventListener('scroll', () => {
      const scrollPosition = window.scrollY;

      if (scrollPosition >= scrollThreshold) {
        button.classList.remove('hidden');
        button.style.display = 'block'; // Show button after small scroll
      } else {
        button.classList.add('hidden');
        button.style.display = 'none'; // Hide button before small scroll
      }
    });
  } else {
    console.error('Button not found.');
  }
});


  $(document).ready(function() {
    $('#custom_back').on('click', function(e) {
      e.preventDefault(); // Prevent the default anchor behavior

      // Set a flag in sessionStorage to indicate that the button's click event should be triggered
      sessionStorage.setItem('triggerReload', 'true');

      // Navigate back two pages
      window.history.go(-2);
    });

    // Check if the flag is set and trigger the button's click event
    if (sessionStorage.getItem('triggerReload') === 'true') {
      // Clear the flag
      sessionStorage.removeItem('triggerReload');

      // Trigger the button's click event
      $('#hiddenButton_reload_win_c').click();
    }
  });





$(document).ready(function() {
  $('.custom-choose-option').on('click', function() {
                  var inputval = $(".product-form").find(".product-variant-id").val();
    var quantity = $(".quantity__input").val();

        $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: {
                id: inputval,
                quantity: quantity
            },
            dataType: "json",
            success: function(response) {
               
               window.location.href = '/checkout';
    
            },
            error: function(error) {
                console.error("Error adding product to cart", error);
                alert('There was an error adding the product to the cart.');
            }
        });
  });

   $('.product_form-input-container .element label').on('click', function() {
     setTimeout(function() {

var pricetext = $(".product__info-wrapper .price__container .price__regular .price-item--regular").text().replace("USD", "").trim();
var compare_price = $(".product__info-wrapper .price__container .price__sale .price-item--regular").text().replace("USD", "").trim();



$(".custom_checkout_price").text(pricetext);
$(".custom_checkout_price_compare").text(compare_price);


var priceValue = parseFloat(pricetext.replace(/[^0-9.-]+/g,"")); // Convert price text to a number
var comparePriceValue = parseFloat(compare_price.replace(/[^0-9.-]+/g,"")); // Convert compare price text to a number

if(comparePriceValue > priceValue) {
    var discount = comparePriceValue - priceValue; // Calculate the discount
    var formattedDiscount = discount.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    $(".save_percent").text(formattedDiscount + " OFF");

}

       }, 2000); // 500 milliseconds = half a second

   });
});

$( window ).on("load", function() {
var pricetext = $(".product__info-wrapper .price__container .price__regular .price-item--regular").text().replace("USD", "").trim();
var compare_price = $(".product__info-wrapper .price__container .price__sale .price-item--regular").text().replace("USD", "").trim();

 $(".custom_checkout_price").text(pricetext);
       $(".custom_checkout_price_compare").text(compare_price);
  
var priceValue = parseFloat(pricetext.replace(/[^0-9.-]+/g, ""));
    var comparePriceValue = parseFloat(compare_price.replace(/[^0-9.-]+/g, ""));

    if (comparePriceValue > priceValue) {
        var discount = comparePriceValue - priceValue;
        var formattedDiscount = discount.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        $(".save_percent").text(formattedDiscount + " OFF");
    }

  
});










